/* @ngInject */
function userService (ConnectorWebService, CONSTANTS, Utils, $rootScope, NewAssetService, RequestDeduplicationService) {
  var oUserService = {}

  oUserService.fnSetUser = function (oUser) {
    $rootScope.oUser = oUser
  }

  oUserService.refreshUser = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME)
      .then(function (res) {
        oUserService.fnSetUser(res)
        return res
      })
  }

  oUserService.getUser = function (forceReload = false) {
    const getLoggedUserRequest = () => ConnectorWebService.get(CONSTANTS.URL_USERS_ME)
    if (forceReload) {
      return getLoggedUserRequest()
    }
    return RequestDeduplicationService.deduplicateRequest('UserServiceGetUser', getLoggedUserRequest)
  }

  oUserService.getUserCompanies = function (top, skip, params) {
    let url = CONSTANTS.URL_USERS_ME_COMPANIES

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (params && params.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params && params.sort) {
      url = Utils.fnAddQueryToUrl(url, { sort: params.sort })
    }

    if (params && params.active) {
      url = Utils.fnAddQueryToUrl(url, { active: params.active })
    }

    return ConnectorWebService.get(url)
  }

  oUserService.updateContextByUser = function (userId, contextId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_USER_CONTEXT_UPDATE, [userId])

    return ConnectorWebService.put(url, { contextId })
  }

  oUserService.getUserContexts = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME_CONTEXTS)
  }

  oUserService.updateUserCompany = function (iCompanyId) {
    return ConnectorWebService.put(CONSTANTS.URL_USERS_ME_COMPANY, {
      customerCompanyId: iCompanyId
    })
  }

  oUserService.updateUserContext = function (iContextId) {
    return ConnectorWebService.put(CONSTANTS.URL_USERS_ME_CONTEXT, {
      contextId: iContextId
    })
  }

  oUserService.getUserCompany = function (forceReload = false) {
    const getUserCompanyRequest = () => ConnectorWebService.get(CONSTANTS.URL_USERS_ME_COMPANY)
    if (forceReload) {
      return getUserCompanyRequest()
    }

    return RequestDeduplicationService.deduplicateRequest('UserServiceGetUserCompany', getUserCompanyRequest)
  }

  oUserService.getUserCompanyConfigurations = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME_COMPANY_CONFIGURATIONS)
  }

  oUserService.getUploadedImages = function (iTop, iSkip, search) {
    var sUrl = CONSTANTS.URL_USERS_ME_IMAGES

    if (iTop || iSkip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
    }

    if (search) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, { search })
    }

    return ConnectorWebService.get(sUrl)
      .then(function (oResponse) {
        oResponse.d.results = oResponse.d.results.map(function (oImage) {
          return {
            id: oImage.id,
            name: oImage.name,
            contentType: oImage.contentType,
            size: oImage.size,
            src: {
              original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [oImage.id]),
              thumbnail: NewAssetService.getAssetThumbnailUrl(oImage.id, 'LOW', { includeDateAsQueryString: true }),
              optimized: Utils.optimizeAsset(oImage) ? NewAssetService.getAssetThumbnailUrl(oImage.id, 'HIGH', { includeDateAsQueryString: true }) : null
            }
          }
        })
        return oResponse
      }, function (error) {
        return error
      })
  }

  oUserService.createUser = function (oUser, fnSuccessCallback, fnErrorCallback) {
    ConnectorWebService.post(CONSTANTS.URL_AUTH_SIGNUP, oUser)
      .then(function (res) {
        oUserService.fnSetUser(oUser)
        if (fnSuccessCallback) {
          fnSuccessCallback(res)
        }
      }, fnErrorCallback)
  }

  oUserService.login = function (oUser, fnSuccessCallback, fnErrorCallback) {
    ConnectorWebService.post(CONSTANTS.URL_AUTH_LOGIN, oUser)
      .then(function (res) {
        oUserService.fnSetUser(res.data)
        if (fnSuccessCallback) {
          fnSuccessCallback(res)
        }
      }, fnErrorCallback)
  }

  oUserService.updateUser = function (oUser, fnSuccessCallback, fnErrorCallback) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ID, ['me'])
    ConnectorWebService.put(sUrl, oUser)
      .then(fnSuccessCallback, fnErrorCallback)
  }

  oUserService.updateUserPassword = function (user) {
    return ConnectorWebService.put(CONSTANTS.URL_USERS_ME_PASSWORD, user)
  }

  oUserService.rememberPassword = function (sEmail, fnSuccessCallback, fnErrorCallback) {
    ConnectorWebService.post(CONSTANTS.URL_AUTH_RECOVER, { email: sEmail })
      .then(fnSuccessCallback, fnErrorCallback)
  }

  oUserService.changePassword = function (sPassword, token, fnSuccessCallback, fnErrorCallback) {
    var sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_AUTH_RECOVER_TOKEN, [token])
    ConnectorWebService.post(sUrl, { password: sPassword })
      .then(fnSuccessCallback, fnErrorCallback)
  }

  oUserService.getUserFromSession = function () {
    if ($rootScope.oUser) {
      return new Promise(function (resolve, reject) {
        resolve($rootScope.oUser)
      })
    } else {
      return oUserService.getUser()
    }
  }

  oUserService.getAdministratorsAndDesigners = function (options = {}) {
    const {
      top: $top,
      skip: $skip,
      search
    } = options
    let url = CONSTANTS.URL_USERS_ADMINISTRATORS_DESIGNERS

    if ($top) {
      url = Utils.fnAddQueryToUrl(url, { $top })
    }

    if ($skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  oUserService.getCurrentUserCompleteData = function () {
    return oUserService.getUserFromSession().then(function (oUserFromSession) {
      return ConnectorWebService.get(CONSTANTS.URL_USERS + '/me/extended')
    })
  }

  oUserService.getSocialAccounts = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME + '/socialAccounts')
  }

  oUserService.shareArtOnSocialAccount = function (mParams) {
    return ConnectorWebService.post(CONSTANTS.URL_USERS_ME + '/arts/' + mParams.artId + '/share', {
      externalId: mParams.externalId,
      message: mParams.message
    })
  }

  oUserService.getOwnedUsers = function (params) {
    let url = CONSTANTS.URL_USERS_ME_GROUP_USERS

    if (params.search) {
      url = Utils.fnAddQueryToUrl(url, { search: params.search })
    }

    if (params.$top) {
      url = Utils.fnAddQueryToUrl(url, { $top: params.$top })
    }

    if (params.$skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip: params.$skip })
    }

    return ConnectorWebService.get(url)
  }

  oUserService.removeSocialAccount = function (mParams) {
    return ConnectorWebService.fnDelete(CONSTANTS.URL_USERS_ME + '/socialAccounts/' + mParams.externalId)
  }

  oUserService.resyncSocialAccounts = function (mParams) {
    return ConnectorWebService.post(CONSTANTS.URL_USERS_ME + '/socialAccounts/resync', {
      type: mParams.type
    })
  }

  oUserService.getLoginCount = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_LOGIN_COUNT)
  }

  oUserService.getArtsCount = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ART_COUNT)
  }

  oUserService.getTasks = function (iTop, iSkip, oFilters) {
    var sUrl = CONSTANTS.URL_USERS_ME_TASKS

    if (iTop || iSkip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
    }

    if (oFilters) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, oFilters)
    }

    return ConnectorWebService.get(sUrl)
  }

  oUserService.getPostNotificationsCount = function () {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_ME_CHECK_UNREAD_POSTS)
  }

  oUserService.updateUserLocale = function (locale) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_USERS_ME_LANGUAGE_CODE)

    return ConnectorWebService.put(sUrl, {
      locale
    })
  }

  oUserService.getUserProfileImage = function (id, updated) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_USER_PROFILE_IMAGE, [id])

    if (updated) {
      url = Utils.fnAddQueryToUrl(url, { cache: updated })
    } else if ($rootScope.oUser) {
      const updatedAt = $rootScope.oUser.updatedAt
      url = Utils.fnAddQueryToUrl(url, { cache: updatedAt })
    }

    return url
  }

  oUserService.sendUserMetricsToExternalPlatforms = function () {
    const url = CONSTANTS.URL_USERS_METRICS_SEND

    return ConnectorWebService.post(url)
  }

  oUserService.sendUserCompanyMetricsToExternalPlatforms = function () {
    const url = CONSTANTS.URL_CUSTOMER_COMPANIES_METRICS_SEND

    return ConnectorWebService.post(url)
  }

  oUserService.getUsersMention = function (input = {}) {
    const { search, $top, $skip } = input
    let url = CONSTANTS.URL_USERS_MENTION
    if (search) url = Utils.fnAddQueryToUrl(url, { search })
    if ($top)url = Utils.fnAddQueryToUrl(url, { $top })
    if ($skip)url = Utils.fnAddQueryToUrl(url, { $skip })
    return ConnectorWebService.get(url)
  }

  oUserService.getBasicUsersInfo = function (role, active) {
    let url = CONSTANTS.URL_USERS_BASIC

    if (role) {
      url = Utils.fnAddQueryToUrl(url, { role })
    }

    if (active) {
      url = Utils.fnAddQueryToUrl(url, { active })
    }

    return ConnectorWebService.get(url)
  }

  oUserService.updateShowArtsMigrationDialogCount = () => {
    const url = CONSTANTS.URL_USERS_ARTS_DIALOG_COUNT
    return ConnectorWebService.put(url)
  }

  oUserService.updateSkipArtsMigrationDialog = () => {
    const url = CONSTANTS.URL_USERS_ARTS_DIALOG_SKIP
    return ConnectorWebService.put(url)
  }

  oUserService.getFeatures = () => {
    const url = CONSTANTS.URL_USERS_FEATURES
    return ConnectorWebService.get(url)
  }

  oUserService.getUserByVerificationToken = (verificationToken) => {
    if (!verificationToken) {
      throw new Error('verificationToken is missing')
    }

    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_EXTERNAL_USER_VERIFICATION, { emailSecretToken: verificationToken })
    return ConnectorWebService.get(url)
  }

  oUserService.resendUserVerificationEmail = (verificationToken) => {
    const url = CONSTANTS.URL_EXTERNAL_USER_VERIFICATION_EMAIL_RESEND

    return ConnectorWebService.post(url, {
      emailSecretToken: verificationToken
    })
  }

  oUserService.verifySSOUser = (verificationToken, securityCode) => {
    const url = CONSTANTS.URL_EXTERNAL_SSO_USER_VERIFICATION

    return ConnectorWebService.post(url, {
      userConfirmationCode: securityCode,
      emailSecretToken: verificationToken
    })
  }

  oUserService.getUserNotificationsConfig = () => {
    return ConnectorWebService.get(CONSTANTS.URL_USERS_NOTIFICATIONS_CONFIG)
  }

  oUserService.updateUserNotificationsConfig = (info) => {
    return ConnectorWebService.put(CONSTANTS.URL_USERS_NOTIFICATIONS_CONFIG, info)
  }

  oUserService.deleteUser = (info, userTargetId) => {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_USERS_DELETE, [info])
    if (userTargetId) {
      url = Utils.fnAddQueryToUrl(url, { userTargetId })
    }

    return ConnectorWebService.fnDelete(url)
  }

  oUserService.restoreUser = (info) => {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_NEW_USERS_RESTORE, [info]))
  }

  oUserService.resendEmailConfirmation = () => {
    const url = CONSTANTS.URL_USERS_ME_EMAIL_CONFIRMATION_RESEND
    return ConnectorWebService.post(url)
  }

  oUserService.verifyEmailConfirmation = (confirmationCode) => {
    const url = CONSTANTS.URL_BACKEND + '/Authentication/email/confirmation/' + confirmationCode
    return ConnectorWebService.get(url)
  }

  /**
   * Traz os consultores da empresa.
   *
   * @param {Object} params
   * @param {number} params.top
   * @param {number} params.skip
   * @param {string} params.search
   * @returns {Promise<Object>}
   */
  oUserService.getConsultants = ({ top = 20, skip = 0, search = null }) => {
    let url = CONSTANTS.URL_USERS
    url = Utils.fnAddQueryToUrl(url, { active: 'true' })
    url = Utils.fnAddQueryToUrl(url, { onlyConsultants: 1 })
    if (top) url = Utils.fnAddQueryToUrl(url, { $top: top })
    if (skip) url = Utils.fnAddQueryToUrl(url, { $skip: skip })
    if (search) url = Utils.fnAddQueryToUrl(url, { search })

    return ConnectorWebService.get(url)
  }

  return oUserService
}

export { userService }
